import _extends from "@babel/runtime/helpers/extends";
/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { jsx } from '@emotion/react';
import { getStyleProps } from '../utils';

// ==============================
// Root Container
// ==============================

export const containerCSS = ({
  isDisabled,
  isRtl
}) => ({
  label: 'container',
  direction: isRtl ? 'rtl' : undefined,
  pointerEvents: isDisabled ? 'none' : undefined,
  // cancel mouse events when disabled
  position: 'relative'
});

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export const SelectContainer = props => {
  const {
    children,
    innerProps,
    isDisabled,
    isRtl
  } = props;
  return jsx("div", _extends({}, getStyleProps(props, 'container', {
    '--is-disabled': isDisabled,
    '--is-rtl': isRtl
  }), innerProps), children);
};

// ==============================
// Value Container
// ==============================

export const valueContainerCSS = ({
  theme: {
    spacing
  },
  isMulti,
  hasValue,
  selectProps: {
    controlShouldRenderValue
  }
}, unstyled) => ({
  alignItems: 'center',
  display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
  flex: 1,
  flexWrap: 'wrap',
  WebkitOverflowScrolling: 'touch',
  position: 'relative',
  overflow: 'hidden',
  ...(unstyled ? {} : {
    padding: `${spacing.baseUnit / 2}px ${spacing.baseUnit * 2}px`
  })
});

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export const ValueContainer = props => {
  const {
    children,
    innerProps,
    isMulti,
    hasValue
  } = props;
  const styles = getStyleProps(props, 'valueContainer', {
    'value-container': true,
    'value-container--is-multi': isMulti,
    'value-container--has-value': hasValue
  });
  return jsx("div", _extends({
    css: styles.css
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    ,
    className: styles.className || 'value-container'
  }, innerProps), children);
};

// ==============================
// Indicator Container
// ==============================

export const indicatorsContainerCSS = () => ({
  alignItems: 'center',
  alignSelf: 'stretch',
  display: 'flex',
  flexShrink: 0
});

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export const IndicatorsContainer = props => {
  const {
    children,
    innerProps
  } = props;
  return jsx("div", _extends({}, getStyleProps(props, 'indicatorsContainer', {
    indicators: true
  }), innerProps), children);
};